import { Component, ChangeDetectionStrategy } from '@angular/core';
import { BreadcrumbService } from '@services/breadcrumb.service';
import { BaseModal } from '../base-modal';

@Component({
	selector: 'delivery-modal',
	styleUrls: ['./delivery.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './delivery.component.html'
})
export class DeliveryComponent extends BaseModal {

	productionTimes = [
		{ name: 'spirit', time: '4 working days' },
		{ name: 'strip', time: '4 working days' },
		{ name: 'air', time: '5 working days' },
		{ name: 'acetanium', time: '5 working days' },
		{ name: 'n.o.w.', time: '5 working days' },
		{ name: 'rim', time: '5 working days' },
		{ name: 'thintanium', time: '5 working days' },
		{ name: 'blok', time: '6 working days' },
		{ name: 'sun', time: '6 working days' },
		{ name: 'buffalo', time: '12 working days' }
	];

	productionTimeNotes = [
		'Forementioned production times are business days (Mondays to Fridays).',
		'Orders placed via Customiser offer the safest and fastest production times.',
		'Novelties are subject to longer production times.',
		'Production times for Precious may vary. Please follow order status at my.keringeyewear → My Account → History → Orders or alternatively contact our Customer Service Team.',
		'Above production times do not include shipping times.'
	];

	constructor(
		breadcrumbService: BreadcrumbService) {
		super(breadcrumbService);
	}

}
